module.exports = __webpack_public_path__ + "static/img/icon zt wt01.680f04ef.svg";